<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">
        お問い合わせ
      </h3>
    </div>
    <div class="page-block__inner">
      <div
        v-if="isBtoC && false"
        class="dashboard-private-message">
        <div class="dashboard-private-message__heading">
          <h3 class="dashboard-private-message__title c-with-icon">
            <!-- eslint-disable max-len -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              shape-rendering="geometricPrecision"
              text-rendering="geometricPrecision"
              image-rendering="optimizeQuality"
              fill-rule="evenodd"
              clip-rule="evenodd"
              viewBox="0 0 511.999 463.377"
              class="icon-my_artist svg-icon">
              <path
                class="color1"
                d="M289.639 9.137c12.411 7.25 23.763 18.883 33.037 34.913l.97 1.813 1.118 1.941 174.174 302.48c33.712 56.407-1.203, 113.774-66.174 112.973v.12H73.485c-.895 0-1.78-.04-2.657-.112-59.104-.799-86.277-54.995-61.909-106.852.842-1.805 1.816-3.475 2.816-5.201L189.482 43.959l-.053-.032c9.22-15.786 20.717-27.457 33.411-34.805C243.788-3 268.711-3.086 289.639 9.137zM255.7 339.203c13.04 0 23.612 10.571 23.612 23.612 0 13.041-10.572 23.613-23.612 23.613-13.041 0-23.613-10.572-23.613-23.613s10.572-23.612 23.613-23.612zm17.639-35.379c-.794 19.906-34.506 19.931-35.278-.006-3.41-34.108-12.129-111.541-11.853-143.591.284-9.874 8.469-15.724 18.939-17.955 3.231-.686 6.781-1.024 10.357-1.019 3.595.008 7.153.362 10.387 1.051 10.818 2.303 19.309 8.392 19.309 18.446l-.043 1.005-11.818 142.069zM37.596 369.821L216.864 59.942c21.738-37.211 56.225-38.289 78.376 0l176.298 306.166c17.177 28.285 10.04 66.236-38.774 65.488H73.485c-33.017.756-52.841-25.695-35.889-61.775z" /></svg>
            <!-- eslint-enable max-len -->
            サポート窓口からのお知らせ
          </h3>
        </div>
        <p class="dashboard-private-message__desc">
          ＜アーティストページや楽曲の紐付け修正について＞<br>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSf172LGPQVEk74NAdmgTt6xq8MJo4B5WjZuinicjyoYteMwmg/viewform"
            class="c-text-link"
            target="_blank">【narasu】 アーティストページ修正受付フォーム</a>よりご依頼を承っております。
        </p>
        <p class="dashboard-private-message__desc">
          ＜YouTubeに関するお問い合わせについて＞<br>
          以下のお手続きに関しては、<a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdURkj1WpHkm8SWomZu_Hex0OPD9J2IF1zwFie3l9OP9CHIKg/viewform"
            class="c-text-link"
            target="_blank">【narasu】YouTubeお手続き受付フォーム</a>よりご依頼を承っております。
          <ul
            class="faq-result"
            style="margin:20px 0;">
            <li>ご自身の楽曲を利用したYouTube動画に対する、著作権侵害申し立ての取り下げ </li>
            <li>YouTubeのトピックチャンネル修正、新規作成</li>
            <li>YouTubeチャンネルの公式アーティストチャンネル化（OAC）</li>
          </ul>
          本問い合わせフォームではなく、お手続き受付フォームよりご連絡をお願いいたします。
        </p>
      </div>

      <contact-confirm
        v-if="showConfirmation"
        :form="form"
        :inputs="inputs"
        :input-patterns="inputPatterns"
        :image="previewImage"
        :selected-choices="selectedChoices"
        @change-clicked="onChangeClicked"
        @send-clicked="onSendClicked">
      </contact-confirm>
      <div
        v-else-if="isBtoC"
        class="profile-info">
        <h3>
          以下の内容をご入力ください。
        </h3>
        <form
          :class="{ 'form--error': errors }"
          @submit.prevent="submitForm">
          <div
            class="form-wrap form-wrap--profile u-no-margin-top"
            style="padding: 0 10px;">
            <div
              v-for="(question,i) in selectedQuestions"
              :key="question.id"
              class="select-questions">
              <div>
                <label
                  class="control-label">
                  {{ question.label }}
                </label>
                <div
                  class="c-select_wrap"
                  style="width:100%">
                  <select
                    id="type"
                    class="form-control c-select"
                    style="width:100%"
                    @change="onChangeChoice">
                    <option
                      value=""
                      disabled
                      :selected="!choicedIds[i]"
                      style="display:none;">
                      選択してください
                    </option>
                    <option
                      v-for="choice in question.contact_question_choices"
                      :key="choice.id"
                      :value="question.id+'-'+choice.id"
                      :selected="choicedIds[i] === choice.id">
                      {{ choice.label }}
                    </option>
                  </select>
                </div>
                <!-- eslint-disable vue/no-v-html -->
                <div
                  v-if="annotations[i]"
                  v-html="annotations[i]">
                </div>
                <!-- eslint-enable vue/no-v-html -->
              </div>
            </div>

            <div
              v-if="suggestions.length>0"
              class="suggestions">
              よくある質問
              <div
                v-for="suggestion in suggestions"
                :key="suggestion.id">
                <a
                  :href="suggestion.url"
                  class="c-text-link"
                  target="_blank">
                  {{ suggestion.label }}
                </a><br>
              </div>
            </div>
            <div
              v-for="(pattern,index) in inputPatterns"
              :key="pattern.id"
              class="question-inputs">
              <div
                v-if="pattern.type === 'string' || pattern.type === 'problem_store_name'
                  || pattern.type === 'email'"
                :style="index === inputPatterns.length - 1 ?
                  'padding: 0.5em 0;' : 'padding-top: 0.5em;'">
                <label
                  class="control-label"
                  :for="pattern.id">
                  {{ pattern.custom_label || '' }}
                  <span class="req">＊
                  </span>
                </label>
                <input
                  :id="pattern.id"
                  v-model="inputs[pattern.id]"
                  class="form-control"
                  type="text">
                <!-- eslint-disable vue/no-v-html -->
                <div
                  v-if="pattern.input_note"
                  class="form-item-text"
                  v-html="pattern.input_note">
                </div>
                <!-- eslint-enable vue/no-v-html -->
                <p
                  v-if="errors['inputs.'+pattern.id]"
                  class="error-text">
                  {{ errors['inputs.'+pattern.id][0] }}
                </p>
              </div>
              <div
                v-if="pattern.type === 'text'"
                style="padding-top:0.5em;">
                <label
                  class="control-label"
                  :for="pattern.id">
                  {{ pattern.custom_label || '' }}
                  <span class="req">＊
                  </span>
                </label>
                <div class="form-item">
                  <textarea
                    v-model="inputs[pattern.id]"
                    class="c-textarea">
                </textarea>
                  <!-- eslint-disable vue/no-v-html -->
                  <div
                    v-if="pattern.input_note"
                    class="form-item-text"
                    v-html="pattern.input_note">
                  </div>
                  <!-- eslint-enable vue/no-v-html -->
                  <p
                    v-if="errors['inputs.'+pattern.id]"
                    class="error-text">
                    {{ errors['inputs.'+pattern.id][0] }}
                  </p>
                </div>
              </div>
              <div
                v-else-if="pattern.type === 'url'"
                style="padding-top:0.5em;">
                <label
                  class="control-label"
                  :for="pattern.id">
                  {{ pattern.custom_label || '' }}
                  <span class="req">＊
                  </span>
                </label>
                <input
                  :id="pattern.id"
                  v-model="inputs[pattern.id]"
                  class="form-control"
                  type="url">
                <!-- eslint-disable vue/no-v-html -->
                <div
                  v-if="pattern.input_note"
                  class="form-item-text"
                  v-html="pattern.input_note">
                </div>
                <!-- eslint-ensable vue/no-v-html -->
                <p
                  v-if="errors['inputs.'+pattern.id]"
                  class="error-text">
                  {{ errors['inputs.'+pattern.id][0] }}
                </p>
              </div>
              <div
                v-else-if="pattern.type === 'store_checkbox'"
                style="padding-top:0.5em;">
                <div>
                  <label
                    class="control-label"
                    :for="pattern.id">
                    {{ pattern.custom_label || '問題が発生している配信ストアをご選択ください' }}
                    <span class="req">＊
                    </span>
                  </label>
                </div>
                <div
                  v-for="(v,store) in storeTemplates"
                  :key="store"
                  class="checkbox"
                  style="display: block; margin-top: 0.5em;">
                  <label>
                    <input
                      v-model="inputs[pattern.id][store]"
                      type="checkbox">
                    <div class="option-input"></div>
                    {{ store }}
                  </label>
                  <p
                    v-if="errors['inputs.'+pattern.id]"
                    class="error-text">
                    {{ errors['inputs.'+pattern.id][0] }}
                  </p>
                </div>
                <br>
              </div>
              <div
                v-else-if="pattern.type=== 'select_browser'"
                style="padding-top:0.5em;">
                <div>
                  <label
                    class="control-label"
                    :for="pattern.id">
                    {{ pattern.custom_label || 'ご利用中のブラウザをご選択ください※Internet Explorerはご利用いただけません' }}
                    <span class="req">＊
                    </span>
                  </label>
                </div>
                <div
                  class="c-select_wrap"
                  style="display: block;width:100%;">
                  <select
                    id="type"
                    v-model="inputs[pattern.id]"
                    class="form-control c-select"
                    style="width:100%">
                    <option
                      value=""
                      disabled
                      selected
                      style="display:none;">
                      選択してください
                    </option>
                    <option
                      v-for="browser in browserTemplates"
                      :key="browser"
                      :value="browser">
                      {{ browser }}
                    </option>
                  </select>
                  <p
                    v-if="errors['inputs.'+pattern.id]"
                    class="error-text">
                    {{ errors['inputs.'+pattern.id][0] }}
                  </p>
                </div>
                <br>
              </div>
              <div
                v-else-if="pattern.type === 'select_pc'"
                style="padding-top:0.5em;">
                <div>
                  <label
                    class="control-label"
                    :for="pattern.id">
                    {{ pattern.custom_label
                      || 'ご利用端末の詳細をご選択ください。エラーやアラートが表示されている場合は、問題が発生している画面のスクリーンショットをご添付下さいませ' }}
                    <span class="req">＊
                    </span>
                  </label>
                  <!-- eslint-disable vue/no-v-html -->
                  <div
                    v-if="pattern.input_note"
                    class="form-item-text"
                    v-html="pattern.input_note">
                  </div>
                  <!-- eslint-enable vue/no-v-html -->
                </div>
                <div
                  class="c-select_wrap"
                  style="display: block;width:100%;">
                  <select
                    id="type"
                    v-model="inputs[pattern.id]"
                    class="form-control c-select"
                    style="width:100%">
                    <option
                      value=""
                      disabled
                      selected
                      style="display:none;">
                      選択してください
                    </option>
                    <option
                      v-for="pcos in pcosTemplates"
                      :key="pcos"
                      :value="pcos">
                      {{ pcos }}
                    </option>
                  </select>
                  <p
                    v-if="errors['inputs.'+pattern.id]"
                    class="error-text">
                    {{ errors['inputs.'+pattern.id][0] }}
                  </p>
                </div>
                <br>
              </div>
              <div
                v-else-if="pattern.type === 'release_id'"
                style="padding-top:0.5em;">
                <div v-if="!products">
                  <label
                    class="control-label">
                    ログイン時のみ入力いただけます
                  </label>
                </div>
                <div v-else>
                  <label
                    class="control-label"
                    :for="pattern.id">
                    {{ pattern.custom_label || '問題のタイトルを選択してください' }}
                    <span class="req">＊
                    </span>
                  </label>
                  <div
                    v-if="products.length === 0"
                    style="margin-top: 10px;">
                    選択できる楽曲がありません
                  </div>
                  <div
                    v-else
                    class="c-select_wrap"
                    style="display: block;width:100%;">
                    <select
                      id="type"
                      v-model="inputs[pattern.id].release_id"
                      class="form-control c-select"
                      style="width:100%">
                      <option
                        value=""
                        disabled
                        selected
                        style="display:none;">
                        選択してください
                      </option>
                      <option
                        v-for="product in products"
                        :key="product.id"
                        :value="product.release_id">
                        {{ truncate(
                          '('+product.release_id+')'+product.title+' '
                            +product.artist_name) }}
                      </option>
                    </select>
                    <p
                      v-if="errors['inputs.'+pattern.id+'.release_id']"
                      class="error-text">
                      {{ errors['inputs.'+pattern.id+'.release_id'][0] }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else-if="pattern.type === 'release_ids'"
                style="padding-top:0.5em;">
                <div v-if="!products">
                  <label
                    class="control-label">
                    ログイン時のみ入力いただけます
                  </label>
                </div>
                <div v-else>
                  <label
                    class="control-label"
                    :for="pattern.id">
                    {{ pattern.custom_label || '問題のタイトルを選択してください' }}
                    <span class="req">＊
                    </span>
                  </label>
                  <div
                    v-if="products.length === 0"
                    style="margin-top: 10px;">
                    選択できる楽曲がありません
                  </div>
                  <div
                    v-for="(releaseInput,releaseIndex) in inputs[pattern.id]"
                    v-else
                    :key="releaseInput.id">
                    <div
                      style="display: flex; align-items: center; width: 100%;
                                margin-bottom: 5px;">
                      <div
                        class="c-select_wrap"
                        style="flex: 1;">
                        <select
                          id="type"
                          v-model="releaseInput.value"
                          class="form-control c-select"
                          style="width:100%"
                          @change="releaseIdsChanges(pattern.id,releaseIndex)">
                          <option
                            value=""
                            disabled
                            selected
                            style="display:none;">
                            選択してください
                          </option>
                          <option
                            v-for="product in filteredProducts(pattern.id, releaseInput.value)"
                            :key="product.id"
                            :value="product.release_id">
                            {{ truncate(
                              '('+product.release_id+')'+product.title+' '
                                +product.artist_name) }}
                          </option>
                        </select>
                      </div>
                      <button
                        v-if="inputs[pattern.id].length > 1
                          && releaseIndex !== inputs[pattern.id].length - 1"
                        type="button"
                        class="c-btn--delete"
                        style="margin-left: 10px; flex-shrink: 0;"
                        @click.prevent="removeReleaseId(pattern.id, releaseIndex)">
                      </button>
                    </div>
                    <p
                      v-if="errors['inputs.'+pattern.id+'.release_ids']"
                      class="error-text">
                      {{ errors['inputs.'+pattern.id+'.release_ids'][0] }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else-if="pattern.type === 'tracks'">
                <div v-if="!products">
                  <label class="control-label">
                    ログイン時のみ入力いただけます
                  </label>
                </div>
                <div v-else>
                  <label
                    class="control-label"
                    :for="pattern.id">
                    {{ pattern.custom_label || '楽曲を選択し、楽曲名を入力してください' }}
                    <span class="req">＊</span>
                  </label>
                  <!-- eslint-disable vue/no-v-html -->
                  <div
                    v-if="pattern.input_note"
                    class="form-item-text"
                    v-html="pattern.input_note">
                  </div>
                  <!-- eslint-enable vue/no-v-html -->

                  <div
                    v-if="products.length === 0"
                    style="margin-top: 10px;">
                    選択できる楽曲がありません
                  </div>

                  <div
                    v-for="(trackInput, trackIndex) in inputs[pattern.id]"
                    v-else
                    :key="trackInput.id"
                    style="margin-bottom: 15px; border-bottom: 1px dashed #eee;
                    padding-bottom: 15px;">
                    <label style="font-weight: normal;"> {{ (1+trackIndex)+'曲目' }}</label>
                    <div style="display: flex; align-items: center; width: 100%;">
                      <div
                        class="c-select_wrap"
                        style="flex: 1;">
                        <select
                          v-model="trackInput.value"
                          class="form-control c-select"
                          style="width:100%"
                          @change="tracksChanges(pattern.id, trackIndex)">
                          <option
                            value=""
                            disabled
                            selected
                            style="display:none;">
                            リリースタイトルを選択してください
                          </option>
                          <option
                            v-for="product in filteredProducts(pattern.id, trackInput.value)"
                            :key="product.id"
                            :value="product.release_id">
                            {{ truncate('('+product.release_id+')'
                              +product.title+' '+product.artist_name) }}
                          </option>
                        </select>
                      </div>

                      <button
                        v-if="inputs[pattern.id].length > 1
                          && trackIndex !== inputs[pattern.id].length - 1"
                        type="button"
                        class="c-btn--delete"
                        style="margin-left: 10px; flex-shrink: 0;"
                        @click.prevent="removeTracks(pattern.id, trackIndex)">
                      </button>
                    </div>

                    <div
                      v-if="trackInput.value !==''"
                      style="margin-top: 8px;">
                      <input
                        v-model="trackInput.text"
                        type="text"
                        class="form-control"
                        placeholder="楽曲名を入力してください"
                        @input="tracksChanges(pattern.id, trackIndex)">
                    </div>

                    <p
                      v-if="errors['inputs.'+pattern.id+'.'+trackIndex+'.value']"
                      class="error-text">
                      {{ errors['inputs.'+pattern.id+'.'+trackIndex+'.value'][0] }}
                    </p>
                    <p
                      v-if="errors['inputs.'+pattern.id+'.'+trackIndex+'.text']"
                      class="error-text">
                      {{ errors['inputs.'+pattern.id+'.'+trackIndex+'.text'][0] }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else-if="pattern.type === 'phone_number'"
                style="padding-top:0.5em;">
                <div v-if="!products">
                  <label
                    class="control-label">
                    ログイン時のみ入力いただけます
                  </label>
                </div>
                <div v-else>
                  <label
                    class="control-label"
                    :for="pattern.id">
                    {{ pattern.custom_label || '' }}
                    <span class="req">＊
                    </span>
                  </label>
                  <input
                    :id="pattern.id"
                    v-model="inputs[pattern.id]"
                    class="form-control"
                    type="tel"
                    pattern="[0-9]{9,14}">
                  <!-- eslint-disable vue/no-v-html -->
                  <div
                    v-if="pattern.input_note"
                    class="form-item-text"
                    v-html="pattern.input_note">
                  </div>
                  <!-- eslint-enable vue/no-v-html -->
                  <p
                    v-if="errors['inputs.'+pattern.id]"
                    class="error-text">
                    {{ errors['inputs.'+pattern.id][0] }}
                  </p>
                </div>
              </div>
              <div v-else-if="pattern.type === 'default'">
                <div class="form-label">
                  <label
                    class="control-label"
                    for="name">
                    お名前
                    <span class="req">＊
                    </span>
                  </label>
                </div>
                <div class="form-item">
                  <input
                    id="name"
                    v-model="inputs[pattern.id].name"
                    class="form-control"
                    type="text">
                  <p
                    v-if="errors['inputs.'+pattern.id+'.name']"
                    class="error-text">
                    {{ errors['inputs.'+pattern.id+'.name'][0] }}
                  </p>
                </div>
                <div class="form-label">
                  <label
                    class="control-label"
                    for="email">
                    お客様のメールアドレス（ご連絡先）
                    <span class="req">
                      ＊
                    </span>
                  </label>
                </div>
                <div class="form-item">
                  <input
                    id="email"
                    v-model="inputs[pattern.id].email"
                    class="form-control"
                    type="text">
                  <p
                    v-if="errors['inputs.'+pattern.id+'.email']"
                    class="error-text">
                    {{ errors['inputs.'+pattern.id+'.email'][0] }}
                  </p>
                </div>
                <div class="form-label form-label--top">
                  <label
                    class="control-label"
                    for="subject">
                    件名
                    <span class="req">＊</span>
                  </label>
                </div>
                <div class="form-item">
                  <div>
                    <input
                      id="subject"
                      v-model="inputs[pattern.id].subject"
                      class="form-control"
                      type="text"
                      @input="onChangeSubject">
                    <p
                      v-if="errors['inputs.'+pattern.id+'.subject']"
                      class="error-text">
                      {{ errors['inputs.'+pattern.id+'.subject'][0] }}
                    </p>
                  </div>
                </div>
                <div class="form-label form-label--top">
                  <label
                    class="control-label"
                    for="body">
                    <span>お問い合わせ（内容の詳細）</span>
                    <span class="req">
                      ＊
                    </span>
                  </label>
                </div>
                <div class="form-item">
                  <textarea
                    id="body"
                    v-model="inputs[pattern.id].body"
                    class="c-textarea">
                </textarea>
                  <p
                    class="form-item-text"
                    style="margin-bottom: 0;">
                    リリースタイトル・アーティスト名などは詳しくご入力ください。 <br>サポートチームができるだけ早く対応いたします。
                  </p>
                  <p
                    v-if="errors['inputs.'+pattern.id+'.body']"
                    class="error-text"
                    style="margin-top: 0;">
                    {{ errors['inputs.'+pattern.id+'.body'][0] }}
                  </p>
                </div>
                <div
                  class="form-label"
                  style="padding-top:10px;padding-bottom: 10px;">
                  <label
                    class="control-label"
                    for="body">
                    添付ファイル
                  </label>
                </div>
                <div
                  class="form-item image-form"
                  style="padding-bottom:10px">
                  <a
                    v-if="!previewImage"
                    class="c-btn c-btn--download--narrow"
                    style="color: #fff;text-decoration: none;"
                    href="#"
                    @click.prevent="onUploadClicked">
                    ファイルをアップロード
                    <img
                      v-if="!previewImage"
                      src="/img/common/icon-download_white.png"
                      alt=""
                      class="form-item-text">
                  </a>
                  <img
                    v-if="previewImage"
                    style="max-width: 320px; padding-left:10px;"
                    :src="previewImage">
                  <div
                    class="delete-area"
                    style="padding-left:10px;">
                    <button
                      v-if="previewImage"
                      style="margin: 10px 0 0 0;"
                      type="button"
                      class="c-btn--delete"
                      @click.prevent="previewImage=''">
                    </button>
                  </div>
                  <p
                    style="margin-top:10px">
                    より早く解決するためには、スクリーンショットを添付ファイルに追加してください。<br>
                    jpg/gif/png/tiffの画像ファイルのみアップロードできます。
                  </p>

                  <p
                    v-for="(uploadError, ei) in uploadErrors"
                    :key="ei"
                    class="error-text">
                    {{ uploadError }}
                  </p>
                  <p
                    v-if="errors.image"
                    class="error-text">
                    {{ errors.image[0] }}
                  </p>
                  <input
                    ref="file"
                    type="file"
                    style="display:none"
                    accept="image/png,image/jpeg,image/gif,image/tiff"
                    @change="onFileChanged" />
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="inputPatterns.length>0"
            class="consent-checkbox-area">
            <div class="checkbox">
              <label>
                <input
                  v-model="confirmed"
                  type="checkbox">
                <div class="option-input"></div>
                <router-link
                  link
                  :to="{ name: 'privacy' }"
                  class="c-text-link"
                  target="_blank">
                  個人情報保護方針
                </router-link>
                に同意して送信する
              </label>
            </div>
          </div>
          <div class="c-btn-wrap">
            <a
              class="c-btn"
              :class="{ 'c-btn--off' : !enableConfirmBtn }"
              @click.prevent="validate">
              内容を確認
              <span class="c-btn__icon-arrow">
              </span>
            </a>
          </div>
        </form>
      </div>
      <div
        v-else
        class="profile-info">
        <form
          :class="{ 'form--error': errors }"
          @submit.prevent="submitForm">
          <div class="form-wrap form-wrap--profile u-no-margin-top">
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="name">
                  お名前
                  <span class="req">＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="name"
                  v-model="form.name"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.name"
                  class="error-text">
                  {{ errors.name[0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="email">
                  お客様のメールアドレス（ご連絡先）
                  <span class="req req--absolute">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="email"
                  v-model="form.email"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.email"
                  class="error-text">
                  {{ errors.email[0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="type">
                  お問い合わせ内容
                  <span class="req">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <div class="form-item-inline">
                  <div class="c-select_wrap">
                    <select
                      id="type"
                      v-model="form.type"
                      class="form-control c-select">
                      <option
                        value=""
                        disabled
                        selected
                        style="display:none;">
                        お問い合わせ内容を選択してください
                      </option>
                      <option
                        v-for="item in contact_types"
                        :key="item.value"
                        :value="item.text">
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                  <p
                    v-if="errors.type"
                    class="error-text">
                    {{ errors.type[0] }}
                  </p>
                </div>
              </div>
            </div>

            <div
              v-if="form.type!=='配信停止について' && form.type!=='キャンペーン応募'"
              class="form-group">
              <div class="form-label form-label--top">
                <label
                  class="control-label"
                  for="subject">
                  件名
                  <span class="req">＊</span>
                </label>
              </div>
              <div class="form-item">
                <div>
                  <input
                    id="subject"
                    v-model="form.subject"
                    class="form-control"
                    type="text"
                    @input="onChangeSubject">
                  <p
                    v-if="errors.subject"
                    class="error-text">
                    {{ errors.subject[0] }}
                  </p>
                </div>
                <div
                  v-if="faqs.length>0"
                  class="form-suggest-faqs">
                  <h3>下記のよくある質問もご参考ください</h3>
                  <ul class="faq-result">
                    <li
                      v-for="faq in faqs"
                      :key="`faq${faq.id}`">
                      <router-link
                        :to="{ name: 'faq-detail', params: { id: faq.id }}"
                        target="_blank"
                        class="c-text-link">
                        {{ faq.title }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              v-if="form.type==='配信停止について' || form.type==='キャンペーン応募'"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="release_title">
                  <span v-if="form.type==='キャンペーン応募'">応募するリリースタイトル</span>
                  <span v-else>対象リリースタイトル</span>
                  <span class="req req--absolute">
                    ＊
                  </span>
                </label>
              </div>
              <div
                class="form-item">
                <input
                  id="release_title"
                  v-model="form.release_title"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.release_title"
                  class="error-text">
                  {{ errors.release_title[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="form.type==='配信停止について' || form.type==='キャンペーン応募'"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="artist_name">
                  <span v-if="form.type==='キャンペーン応募'">応募する対象アーティスト名</span>
                  <span v-else>対象アーティスト名</span>
                  <span class="req req--absolute">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="artist_name"
                  v-model="form.artist_name"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.artist_name"
                  class="error-text">
                  {{ errors.artist_name[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="form.type==='キャンペーン応募'"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="artist_name">
                  応募規約の同意
                  <span class="req req--absolute">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <div class="checkbox">
                  <label>
                    <input
                      v-model="campaignAccept"
                      type="checkbox">
                    <div class="option-input"></div>
                    <a
                      href="/client/static/cam202204-01"
                      class="c-text-link"
                      target="_blank">応募規約</a>
                    に同意する
                  </label>
                </div>
                <p
                  v-if="errors.agree"
                  class="error-text">
                  {{ errors.agree[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="form.type==='配信停止について' && isBtoC"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="release_id">
                  リリースID
                  <span class="req req--absolute">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="release_id"
                  v-model="form.release_id"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.release_id"
                  class="error-text">
                  {{ errors.release_id[0] }}
                </p>
                ※リリースIDの確認方法は
                <router-link
                  :to="{ name: 'faq-detail', params: { id: 205 }}"
                  target="_blank"
                  class="c-text-link">
                  こちら
                </router-link>
              </div>
            </div>

            <div
              v-if="form.type==='配信停止について' && !isBtoC"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="jan">
                  対象JANコード
                </label>
              </div>
              <div class="form-item">
                <input
                  id="jan"
                  v-model="form.jan"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.jan"
                  class="error-text">
                  {{ errors.jan[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="form.type!=='キャンペーン応募'"
              class="form-group">
              <div class="form-label form-label--top">
                <label
                  class="control-label"
                  for="body">
                  <span v-if="form.type==='配信停止について'">配信停止理由</span>
                  <span v-else>お問い合わせ（内容の詳細）</span>
                  <span class="req">
                    ＊
                  </span>
                </label>
              </div>
              <div class="form-item">
                <textarea
                  id="body"
                  v-model="form.body"
                  class="c-textarea">
                </textarea>
                <p class="form-item-text">
                  リリースタイトル・アーティスト名などは詳しくご入力ください。 <br>サポートチームができるだけ早く対応いたします。
                </p>
                <p
                  v-if="errors.body"
                  class="error-text">
                  {{ errors.body[0] }}
                </p>
              </div>
            </div>
            <div
              v-if="form.type!=='キャンペーン応募'"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="body">
                  添付ファイル
                </label>
              </div>
              <div class="form-item">
                <a
                  v-if="!previewImage"
                  class="c-btn c-btn--download--narrow"
                  href="#"
                  @click.prevent="onUploadClicked">
                  ファイルをアップロード
                  <img
                    src="/img/common/icon-download_white.png"
                    alt="">
                </a>
                <p
                  v-if="!previewImage"
                  class="form-item-text">
                  より早く解決するためには、スクリーンショットを添付ファイルに追加してください。<br>
                  jpg/gif/png/tiffの画像ファイルのみアップロードできます。
                </p>
                <img
                  v-if="previewImage"
                  style="max-width: 320px"
                  :src="previewImage">

                <div class="delete-area">
                  <button
                    v-if="previewImage"
                    style="margin: 10px 0;"
                    type="button"
                    class="c-btn--delete"
                    @click.prevent="previewImage=''">
                  </button>
                </div>

                <p
                  v-for="(uploadError, index) in uploadErrors"
                  :key="index"
                  class="error-text">
                  {{ uploadError }}
                </p>
                <p
                  v-if="errors.image"
                  class="error-text">
                  {{ errors.image[0] }}
                </p>
                <input
                  ref="file"
                  type="file"
                  style="display:none"
                  accept="image/png,image/jpeg,image/gif,image/tiff"
                  @change="onFileChanged" />
              </div>
            </div>
          </div>
          <div class="consent-checkbox-area">
            <div class="checkbox">
              <label>
                <input
                  v-model="confirmed"
                  type="checkbox">
                <div class="option-input"></div>
                <router-link
                  link
                  :to="{ name: 'privacy' }"
                  class="c-text-link"
                  target="_blank">
                  個人情報保護方針
                </router-link>
                に同意して送信する
              </label>
            </div>
          </div>
          <div class="c-btn-wrap">
            <a
              class="c-btn"
              :class="{ 'c-btn--off' : !enableConfirmBtn }"
              @click.prevent="validate">
              内容を確認
              <span class="c-btn__icon-arrow">
              </span>
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import lodash from 'lodash'
import base64ToBinary from '../../../logic/image'
import ContactConfirm from './Confirm'
import HeaderBar from '../HeaderBar'

export default {
  name: 'Contact',
  components: { HeaderBar, ContactConfirm },
  data() {
    return {
      confirmed: false,
      campaignAccept: false,
      showConfirmation: false,
      form: {
        name: '',
        email: '',
        type: '',
        subject: '',
        body: '',
        release_title: '',
        artist_name: '',
        jany: '',
        image: '',
        requested_user_id: null,
      },
      contact_types: [
        { value: '1', text: 'サイトについて' },
        { value: '2', text: '楽曲について' },
        { value: '3', text: '配信について' },
        { value: '13', text: 'キャラクター使用許諾の申請' },
        { value: '4', text: 'アカウントについて' },
        { value: '6', text: 'アカウント復帰依頼' },
        { value: '7', text: 'ログインについて' },
        { value: '8', text: '配信停止について' },
        { value: '10', text: 'YouTube楽曲利用申請' },
        { value: '11', text: 'キャンペーン応募' },
        { value: '12', text: 'キャンペーンについて' },
        { value: '14', text: '著作権サービスについて' },
        { value: '15', text: 'スプリットについて' },
        { value: '16', text: 'サブスクプランについて' },
        { value: '9', text: 'その他' },
      ],
      questions: [],
      selectedQuestions: [],
      choicedIds: [],
      currentChoiceId: null,
      suggestions: [],
      inputs: {},
      inputPatterns: [],
      is_replyable: false,
      storeTemplates: {
        'Apple Music/iTunes': false,
        Spotify: false,
        'Amazon Music': false,
        AWA: false,
        'LINE MUSIC': false,
        'KKBOX/auミュージックパス': false,
        'YouTube Music': false,
        '楽天 MUSIC': false,
        'レコチョク/dミュージック powered by レコチョク /Music Store powered by レコチョク': false,
        Deezer: false,
        Anghami: false,
        JioSaavn: false,
        NetEase: false,
        'Tencent/QQ Music/Kugou Music/Kuwo Music/We Sing/Ultimate Music': false,
        'dヒッツ/OTORAKU/WEDDING MUSIC BOX': false,
        FLO: false,
        Melon: false,
        'Bugs!': false,
        'Naver VIBE': false,
        Genie: false,
        TIDAL: false,
        Qobuz: false,
        'ドワンゴジェイピー/animelo mix/K-POP Life/ビルボード公式 /ドワンゴジェイピー for スゴ得': false,
        'music.jp': false,
        '7Digital': false,
        mora: false,
        TikTok: false,
      },
      browserTemplates: [
        'Google Chrome',
        'Safari',
        'Firefox',
        'その他',
        '不明',
      ],
      pcosTemplates: [
        'Mac',
        'Windows',
        'iOS',
        'Android',
        'その他',
        '不明',
      ],
      products: false,
      errors: [],
      previewImage: null,
      uploadErrors: [],
      faqs: [],
      annotations: [],
      releaseIdsCounter: 0,
      tracksCounter: 0,
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    enableConfirmBtn() {
      if (this.form.type !== 'キャンペーン応募' && this.confirmed) {
        return true
      }
      if (this.form.type === 'キャンペーン応募' && this.confirmed && this.campaignAccept) {
        return true
      }
      return false
    },
    selectedChoices() {
      if (!this.isBtoC || this.selectedQuestions.length === 0) {
        return []
      }

      return this.selectedQuestions.map((question, index) => {
        const choiceId = this.choicedIds[index]
        if (!choiceId) {
          return { question: question.label, answer: '（未選択）' }
        }

        const choice = question.contact_question_choices.find(c => c.id === choiceId)
        return {
          question: question.label,
          answer: choice ? choice.label : '（不明な選択）',
        }
      })
    },
  },
  mounted() {
    if (this.isBtoC) {
      this.fetchQuestions()
      if (this.$store.state.auth.id) {
        this.fetchProducts()
      }
      // 「キャンペーン応募」はログイン時のみ表示(現在は一時的に非表示また復活予定)
      this.contact_types = this.contact_types.filter(type => type.value !== '10' && type.value !== '11')
    }
    if (this.isBtoB) {
      this.contact_types = this.contact_types.filter(type => type.value !== '11' && type.value !== '12')
    }
  },
  methods: {
    async fetchQuestions() {
      const { data } = await window.axios.get('/api/client/contact-questions')
      this.questions = data
      this.selectedQuestions.push(data[0])
      this.annotations.push(data[0].annotation || '')
    },
    async fetchProducts() {
      try {
        const { data } = await window.axios.get('/api/client/contact-products')
        this.products = data
      } catch (e) {
        this.products = false
      }
    },
    onChangeChoice(event) {
      const selectId = parseInt(event.target.value.split('-')[0], 10)
      const choiceIndex = this.selectedQuestions.findIndex(q => q.id === selectId)
      this.selectedQuestions.splice(choiceIndex + 1)
      this.choicedIds.splice(choiceIndex)
      this.annotations.splice(choiceIndex)

      const choiceId = parseInt(event.target.value.split('-')[1], 10)
      this.currentChoiceId = choiceId
      this.choicedIds.push(choiceId)
      this.confirmed = false
      this.is_replyable = false
      const q = this.selectedQuestions.at(-1)
      const choice = q.contact_question_choices.find(c => c.id === choiceId)
      if (choice) {
        if (choice.requires_login && !this.isLoggedIn) {
          this.currentChoiceId = null
          this.inputPatterns = []
          this.inputs = {}
          this.suggestions = []
          this.annotations.push('本設問へのお問い合わせには、narasuへのログインが必要です。<br>お手数ですが<a href="https://narasu.jp/client/login">こちら</a>よりログイン後、再度ご入力をお願いいたします。')
          return
        }
        if (choice.is_replyable) {
          this.is_replyable = choice.is_replyable
        }
        if (choice.annotation) {
          this.annotations.push(choice.annotation)
        } else {
          this.annotations.push('')
        }

        // 次の選択肢がある場合
        if (choice.next_question_id) {
          this.selectedQuestions
            .push(this.questions.find(question => question.id === choice.next_question_id))
        }
        // サジェスチョンがある場合
        if (choice.contact_question_choice_suggestions.length > 0) {
          this.suggestions = choice.contact_question_choice_suggestions
        } else {
          this.suggestions = []
        }
        // 入力フォームがある場合
        if (choice.contact_question_inputs.length > 0) {
          this.inputPatterns = choice.contact_question_inputs
          this.inputs = {}
          this.inputPatterns.forEach(p => {
            if (p.type === 'release_id') {
              this.inputs[p.id] = {
                release_id: null,
                title: null,
                artist: null,
              }
            } else if (p.type === 'store_checkbox') {
              this.inputs[p.id] = this.storeTemplates
            } else if (p.type === 'release_ids') {
              this.releaseIdsCounter = 0 // カウンターをリセット
              const initialData = [{ id: this.releaseIdsCounter, value: '' }]
              this.$set(this.inputs, p.id, initialData)
            } else if (p.type === 'tracks') {
              this.tracksCounter = 0
              const initialData = [{ id: this.tracksCounter, value: '', text: '' }]
              this.$set(this.inputs, p.id, initialData)
            } else if (p.type === 'default') {
              this.inputs[p.id] = {
                name: null, email: null, subject: null, body: null,
              }
            }
          })
        } else {
          this.inputPatterns = []
        }
      }
    },
    onChangeClicked() {
      window.scrollTo(0, 0)
      this.showConfirmation = false
      this.confirmed = false
    },
    async onSendClicked() {
      const config = { headers: { 'content-type': 'multipart/form-data' } }
      const formData = new FormData()
      const params = this.isBtoC ? { confirmed: true } : this.form
      if (this.isBtoC) {
        params.questions = this.selectedQuestions.map(q => q.id)
        params.choice = this.choicedIds
      } else {
        params.confirmed = true
      }
      if (this.isLoggedIn) {
        params.requested_user_id = this.$store.state.auth.id
      }
      if (this.previewImage && this.previewImage.indexOf('/') !== 0) {
        const base64String = this.previewImage.substr(this.previewImage.indexOf(',') + 1) // 先頭に制御文字があるので除去
        params.image = base64ToBinary(base64String)
      }
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key] !== null ? params[key] : '')
      })
      Object.keys(this.inputs).forEach((input) => {
        const pattern = this.inputPatterns.find(p => String(p.id) === String(input))
        const value = this.inputs[input]

        if (!pattern) return

        if (pattern.type === 'release_ids') {
          if (Array.isArray(value)) {
            value
              .map(v => v.value)
              .filter(v => v !== '')
              .forEach((v, i) => {
                formData.append(`inputs[${input}][${i}]`, v)
              })
          }
        } else if (pattern.type === 'tracks') {
          if (Array.isArray(value)) {
            let index = 0
            value.forEach((item) => {
              if ((!item.value) && (!item.text)) return

              formData.append(`inputs[${input}][${index}][value]`, item.value || '')
              formData.append(`inputs[${input}][${index}][text]`, item.text || '')
              index += 1
            })
          }
        } else if (typeof value === 'object' && value !== null) {
          Object.keys(value).forEach((k) => {
            formData.append(`inputs[${input}][${k}]`, value[k])
          })
        } else {
          formData.append(`inputs[${input}]`, value)
        }
      })
      window.sessionStorage.setItem('is_replyable', this.is_replyable)
      await window.axios.post('/api/client/contact', formData, config)
      this.$router.push({ name: 'contact-complete' })
    },
    async validate() {
      try {
        if (this.isBtoC) {
          const params = {}
          const cleanInputs = structuredClone(this.inputs)

          this.inputPatterns.forEach(pattern => {
            if (pattern.type === 'release_ids' && Array.isArray(cleanInputs[pattern.id])) {
              cleanInputs[pattern.id] = cleanInputs[pattern.id]
                .map(item => item.value)
                .filter(val => val !== '')
            } else if (pattern.type === 'tracks' && Array.isArray(cleanInputs[pattern.id])) {
              cleanInputs[pattern.id] = cleanInputs[pattern.id]
                .filter(item => item.value !== '' || item.text !== '')
            }
          })

          params.inputs = cleanInputs
          params.questions = this.selectedQuestions.map(q => q.id)
          params.choice = this.choicedIds
          await window.axios.post('/api/client/contact', params)
        } else {
          await window.axios.post('/api/client/contact', this.form)
        }
        this.showConfirmation = true
        this.$nextTick(() => {
          const container = document.querySelector('.main-container')
          if (container) {
            container.scrollTo(0, 0)
          } else {
            window.scrollTo(0, 0) // フォールバック
          }
        })
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
        if (this.isBtoC) {
          Object.keys(errors).forEach(e => {
            if (e.slice(0, 6) !== 'inputs') { return }
            this.errors[e] = this.errors[e].map(s => {
              if (s.match(/^正しい形式/)) {
                return '正しい形式を指定してください'
              }
              return `この設問${s.slice(s.search(/は/))}`
            })
          })
        }
        const isConfirmOnlyError = response.status === 422
          && Object.keys(errors).length === 1
          && Object.prototype.hasOwnProperty.call(errors, 'confirmed')

        this.showConfirmation = isConfirmOnlyError
        this.$nextTick(() => {
          const container = document.querySelector('.main-container')
          if (container) {
            container.scrollTo(0, 0)
          } else {
            window.scrollTo(0, 0) // フォールバック
          }
        })
      }
    },
    // ファイル選択ボタンクリック
    onUploadClicked() {
      if (this.isBtoC) {
        this.$refs.file[0].value = ''
        this.$refs.file[0].click()
      } else {
        this.$refs.file.value = ''
        this.$refs.file.click()
      }
    },
    // ファイル選択時コールバック
    onFileChanged(e) {
      const files = e.target.files || e.dataTransfer.files
      const reader = new FileReader()
      reader.onload = event => {
        this.checkImage(event.target.result)
      }
      reader.readAsDataURL(files[0])
    },
    // 画像のバリデーション
    async checkImage(base64image) {
      this.error = ''
      this.uploadErrors = []
      this.validated = false
      const base64String = base64image.substr(base64image.indexOf(',') + 1) // 先頭に制御文字があるので除去
      const formData = new FormData()
      const config = { headers: { 'content-type': 'multipart/form-data' } }
      formData.append('image', base64ToBinary(base64String))

      const response = await window.axios.post('/api/client/image/validate/contact', formData, config)
      if (response.data.result) {
        this.previewImage = base64image
        this.validated = true
        delete this.errors.image
      } else {
        this.uploadErrors = response.data.messages
        this.validated = false
      }
    },
    async searchFaqs(keyword) {
      if (keyword) {
        const { data } = await window.axios.get(`/api/client/faqs/search/?keyword=${keyword}&page=1`, { headers: { 'X-CMAP-No-Loading': 1 } })
        this.faqs = data.data
      } else {
        this.faqs = []
      }
    },
    // eslint-disable-next-line func-names
    onChangeSubject: lodash.debounce(function (event) {
      this.searchFaqs(event.target.value)
    }, 500),
    filteredProducts(inputId, currentValue) {
      if (!this.products) return []

      const pattern = this.inputPatterns.find(p => p.id === inputId)

      if (pattern && pattern.type === 'tracks') {
        return this.products
      }

      const selectedValues = this.inputs[inputId]
        .map(v => v.value)
        .filter(v => v !== currentValue && v !== '')

      return this.products.filter(product => !selectedValues.includes(product.release_id))
    },
    releaseIdsChanges(inputId, releaseIndex) {
      if (this.inputs[inputId].length - 1 === releaseIndex) {
        // カウンターをインクリメントして新しいIDを生成
        this.releaseIdsCounter += 1
        // 新しいIDと空のvalueを持つオブジェクトを配列に追加
        this.inputs[inputId].push({ id: this.releaseIdsCounter, value: '' })
      }
    },
    removeReleaseId(inputId, index) {
      this.inputs[inputId].splice(index, 1)
    },
    tracksChanges(inputId, index) {
      if (this.inputs[inputId].length - 1 === index) {
        this.tracksCounter += 1
        this.inputs[inputId].push({ id: this.tracksCounter, value: '', text: '' })
      }
    },
    removeTracks(inputId, index) {
      this.inputs[inputId].splice(index, 1)
    },
    truncate(text) {
      const maxLength = 25
      if (text && text.length > maxLength) {
        return `${text.substring(0, maxLength)}...`
      }
      return text
    },
  },
}
</script>

<style scoped>
.form-suggest-faqs{
  margin-top:1em;
}
.form-suggest-faqs h3{
  border-bottom:1px solid #DEDEDE;
  margin-top:0.5em;
  margin-bottom:0.5em;
}
ul.faq-result{
  padding-left:1em;
}
.faq-result li{
  list-style-type:'・';
}
ul.faq-result li::marker{
  font-weight:normal;
}

.profile-info h3{
  padding-left:10px
}

.select-questions::after {
  content: '';
  display: block;
  padding-bottom: 22px;
}

.select-questions div::v-deep {
  font-size: 90%;
  padding-top: 3px;
}

.select-questions div::v-deep a{
  text-decoration: underline;
  color: #ff2289;
}

.select-questions div::v-deep a:hover {
  text-decoration: none;
}

.select-questions label {
  display: flex;
  font-weight: bold;
  padding: 12px 10px 0;
  line-height: 1.7rem;
  font-size: 1.7rem;
  align-items: center;
}

.select-questions select {
  display: flex;
  padding-top: 0px;
  line-height: 1.7rem;
  height: 1.6rem;
  font-size: 1.6rem;
  align-items: center;
}

.suggestions {
  display: inline;
  font-weight: bold;
  padding: 12px 10px 0;
  line-height: 1.7rem;
  height: 1.7rem;
}

.suggestions div {
  font-weight: unset;
  padding: 12px 10px 0;
  line-height: 1.6rem;
}

.question-inputs div label {
  display: inline;
  font-weight: bold;
  padding: 12px 10px 0;
  line-height: 1.7rem;
  font-size: 1.7rem;
  align-items: center;
}
.question-inputs div.checkbox label {
  padding-left: 35px;
}

.question-inputs div.checkbox .option-input{
  position: absolute;
}
.image-form p{
  font-size: 90%;
  padding-left: 10px;
}

.c-btn--download--narrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.c-btn--download--narrow img{
  margin-bottom:0px;
}

.question-inputs ::v-deep a {
  color: #ff2289;
  text-decoration: underline;
  cursor: pointer;
}

.question-inputs ::v-deep a:hover {
  text-decoration: none;
  opacity: 0.8;
}

/* 補足テキスト自体のスタイル調整 */
.question-inputs .form-item-text {
  margin-top: 5px;
  font-size: 1.3rem;
  line-height: 1.6;
}
</style>
